import Button from "@/components/button/Button.tsx";
import {IDPInfo} from "@/lib/types/statuspages.ts";

import {IDPTestBlock} from "./IDPTestBlock.tsx";

interface SAMLTesting {
  idps: IDPInfo[];
  wayflessURL: string;
}

export const SAMLTesting = ({idps, wayflessURL}: SAMLTesting) => {
  return (
    <>
      <div className="row">
        <div className="col">
          <h5 className="spacer-small">SAML Testing Sites</h5>
          <p>
            <em>NOTE: This section is visible to superusers only!!</em>
          </p>
          <p>
            <Button
              size={"large"}
              as={"a"}
              target="_blank"
              referrerPolicy="no-referrer"
              href={wayflessURL}
              className="w-100"
            >
              Trigger SAML Login with Saved Settings
            </Button>
          </p>
        </div>
      </div>
      {idps.map((i, idx) => (
        <div key={`${idx}-${i.name}`} className="row">
          <IDPTestBlock className="col" info={i} />
        </div>
      ))}
    </>
  );
};
